import Vue from 'vue'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config.js'
const {theme} = resolveConfig(tailwindConfig)

Chartkick.options = {
  colors: [
    theme.colors.primary['500'],
    theme.colors.secondary['500'],
    theme.colors.tertiary['500'],
  ],
}

Vue.use(Chartkick.use(Chart))
